import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import RequestDemo from "./pages/RequestDemo";
import WhyFlex from "./pages/WhyFlex";
import OurTeam from "./pages/OurTeam";
import ContactUs from "./pages/ContactUs";
import Package from "./pages/Package";
import LeaseContracts from "./pages/LeaseContacts";
import Features from "./pages/Features";
import Landlord from "./pages/Landlord";
import HelpTutorial from "./pages/HelpTutorial";
import Tennant from "./pages/Tenant";
import Product from "./pages/Product";
import Terms from "./pages/Terms";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ScrollToTop from "./UI/ScrollToTop";
import { ToastContainer } from "react-toastify";
function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="w-full flex flex-col">
        <Header />

        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/why-flex" element={<WhyFlex />} />
            <Route path="/our-team" element={<OurTeam />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/request-demo" element={<RequestDemo />} />
            <Route path="/package" element={<Package />} />
            <Route path="/lease-contracts" element={<LeaseContracts />} />
            <Route path="/features/:slug" element={<Features />} />
            <Route path="/product/:slug" element={<Product />} />
            <Route path="/landlord" element={<Landlord />} />
            <Route path="/features/help-tutorial" element={<HelpTutorial />} />
            <Route path="/tennant" element={<Tennant />} />
            <Route path="/terms-condition" element={<Terms />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Routes>
        </main>

        <Footer />
      </div>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </Router>
  );
}

export default App;
